import { apiClient } from '@app/lib'
import { type ApiEnrollmentsUploadInput, type ApiResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

export const useUploadEnrollments = () => {
  const queryClient = useQueryClient()
  const [progress, setProgress] = useState(0)
  const mutation = useMutation({
    mutationKey: ['uploadDocuments'],
    mutationFn: async ({ file, schoolYearId }: ApiEnrollmentsUploadInput) => {
      // noinspection JSUnusedGlobalSymbols
      const response = await apiClient.put<ApiResponse>(
        `/api/enrollments/${schoolYearId}`,
        { file },
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (ev) => {
            if (ev.total) {
              setProgress(Math.round((ev.loaded * 100) / ev.total))
            }
          },
          validateStatus: (status) => status >= 200 && status < 500
        }
      )

      return response?.data
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['enrollments']
      })
  })

  return { ...mutation, progress }
}
